"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var getFormattedDateTime_1 = __importDefault(require("./helpers/getFormattedDateTime"));
var styled_1 = require("./styled");
// eslint-disable-next-line react/prop-types
function EmptyMessage(_a) {
    var date = _a.date;
    return (react_1.default.createElement(styled_1.EmptyMassageContainer, null,
        react_1.default.createElement(styled_1.WorldImage, null),
        react_1.default.createElement(styled_1.EmptyTitle, null, "Lost in the skies?"),
        react_1.default.createElement(styled_1.EmptyDescription, null, "We have not found any flight for"),
        react_1.default.createElement(styled_1.DescriptionHighlight, null, getFormattedDateTime_1.default({ date: date }))));
}
exports.default = EmptyMessage;
//# sourceMappingURL=emptyMessage.js.map